import React from "react";
import { useEffect, useLayoutEffect, useState } from "react";
import "../App.css";
import "../assets/customStyles/custom.css"
import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { Box as GBox, Avatar } from "grommet";
import { Code, Java } from "grommet-icons";
import "typeface-roboto";
import { Link } from "react-router-dom";
import Projects from "./Projects";
import Experience from "./Experience";
import Education from "./Education";
import Skills from "./Skills";
import patternAnimation from "../assets/images/patternAnimatedBg.json";
import stringWavesAnimation from "../assets/images/stringWaves.json";
import terminalAnimation from "../assets/images/terminalWhite.json";
import lottie from "lottie-web";
import Button from "@mui/material/Button";
import logoSvg from "../assets/images/svgMugRedTemp.svg";
import BorderColorIcon from '@mui/icons-material/BorderColor';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import EmailIcon from '@mui/icons-material/Email';
import { Rotate } from "hamburger-react";
function Homepage() {
  let [windowWidth, setWindowWidth] = useState(window.innerWidth)
  useEffect(() => {
    lottie.loadAnimation({
      container: document.querySelector("#code-animation"),
      animationData: stringWavesAnimation,
    });
    lottie.loadAnimation({
      container: document.querySelector("#terminal-animation"),
      animationData: terminalAnimation,
    });
    lottie.loadAnimation({
      container: document.querySelector("#pattern-background"),
      animationData: stringWavesAnimation,
      autoplay: true,
      loop: true
    });
  }, []);



  useLayoutEffect(() => {
    function updateSize() {
      console.log(window.innerWidth)
      setWindowWidth(window.innerWidth);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return (
    <div style={{ marginTop: 65 }}>
      <header
        className="App-header main-background"
        id="Home"
        style={{
          shadows: ["none"],
          paddingTop: 12,
          paddingRight: 0,
          paddingLeft: 0,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        
        }}
      >
        <GBox direction="row" style={{ alignItems: "center", margin: 20, marginTop:'3em', marginBottom:'3em', paddingLeft:30, paddingRight:30, overflow:'hidden' }}>
          <GBox

            animation="zoomIn"
            direction="column"
            style={{ textAlign: "left", width: 500, zIndex:2, }}
          >
            <p style={{ margin: 2 }}>Hi, I am</p>
            <h3 style={{ margin: 2, color: "#079be0" }}>Jatin Arora</h3>
            <h4 style={{ margin: 2 }}>A Full Stack Developer</h4>
            <p style={{ margin: 2 }}>
              I am a passionate, always learning <br/> and  a creative developer.
            </p>
            <GBox direction="row" style={{ minWidth: 300, marginLeft: -5 }}>
              <a style={{ textDecoration: "none" }} href="Resume.pdf" download={true}>
                <Button color="secondary">See my CV</Button></a>{" "}
              <a style={{ textDecoration: "none" }} href="mailto:jatin.arora08@outlook.com"> <Button color="secondary">Connect w/ me</Button></a>
            </GBox>
          </GBox>

          <GBox
            id="ccode-animation"
            direction="column"
            style={{
              alignSelf: "right",
              zIndex:0,
              height:800,
              position: "absolute",
            
            }}
          ></GBox>
        </GBox>


        <GBox
          direction="row-responsive"
          elevation="xlarge"
          style={{ zIndex: 15, padding: 10, margin: 10, background: "#2A2550", justifyContent: "center", alignItems: "center", position: 'relative', paddingLeft: 20, paddingRight: 20, display:'none' }}
          animation="fadeIn"
        >

          <GBox
            direction="row"
            pad="none"
            style={{

              top: -20,
              left: 50,
              position: 'absolute',
            }}
            animation="fadeIn"
          >

            <span
              style={{ fontSize: 30, background: "#241e39", padding: "0 5px" }}
            >
              ABOUT ME
            </span>

          </GBox>

          <div
            style={{
              maxWidth: 600,
              padding: 20,

            }}
          >
            <p style={{ fontSize: 16, color: "#ffffff", fontWeight: 400 }}>
              The first code to output "hello world" was written by me at the
              age of 15 in Java using the well known System.out.println(). Since
              then I have dived into different seas of evergrowing programming
              languages. I have worked on both personal and work projects to
              become a full stack developer and have also built native mobile apps for iOS & Android.
            </p>
          </div>
        </GBox>


        <div id="Technicals" style={{ display: 'flex', flexDirection: 'column', width: '100%', position: 'relative', marginTop: 20, background: '#fff', color: '#000' }}>
          <GBox style={{ marginTop: 10, letterSpacing: 10, fontWeight: 700, display: (windowWidth >= 1100 ? 'none' : 'flex'), width: '100%', justifyContent: 'center' }}>
            <h5 style={{ fontSize: 25 }}> TECHNICALS</h5>
          </GBox>
          <GBox

            pad="none"
            style={{
              marginTop: 10,
              display: (windowWidth < 1100 ? 'none' : 'block'),
              writingMode: 'vertical-rl', transform: 'rotate(180deg)', letterSpacing: 22,
              position: 'absolute', zIndex: 5, left: 90, top: 100
            }}
            animation="fadeIn"
          >

            <span
              style={{ fontSize: 40, fontWeight: 700, marginRight: '15%' }}
            >
              TECHNICALS
            </span>

          </GBox>
          <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
            <GBox
              direction="row-responsive"
              pad="none"
              style={{ margin: 10, width: '100%', justifyContent: 'center' }}
              animation="fadeIn"
            >

              <Skills />
            </GBox>
          </div>
        </div>

        <div id="Projects" style={{ display: 'flex', flexDirection: 'column', width: '100%', position: 'relative', background: '#fe7027' }}>
          <GBox style={{ marginTop: 10, letterSpacing: 10, fontWeight: 700, display: (windowWidth >= 1100 ? 'none' : 'flex'), width: '100%', justifyContent: 'center' }}>
            <h5 style={{ fontSize: 25 }}> PROJECTS</h5>
          </GBox>
          <GBox

            pad="none"
            style={{

              marginTop: 10,
              display: (windowWidth < 1100 ? 'none' : 'block'),
              transform: 'rotate(-90deg)', letterSpacing: 20,
              position: 'absolute', zIndex: 5, left: -70, top: 160
            }}
            animation="fadeIn"
          >

            <span
              style={{ fontSize: 40, fontWeight: 700 }}
            >
              PROJECTS
            </span>

          </GBox>
          <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>
            <GBox
              direction="row-responsive"
              pad="none"
              style={{ margin: 10, alignItems: 'center', justifyContent: 'center' }}
              animation="fadeIn"
            >

              <Projects />
            </GBox>
          </div>
        </div>

        <div id="Experience" style={{ display: 'flex', flexDirection: 'column', width: '100%', position: 'relative', marginTop: 0, overflow: 'hidden' }}>
          <div style={{ left: 0, right: 0, top: (windowWidth > 1000) ? -420 : -720, position: 'absolute', zIndex: 0, width: (windowWidth > 1000) ? '290%' : '550%', height: (windowWidth > 1000) ? '750%' : '320%', overflow: 'hidden', transform: (windowWidth > 1000) ? 'rotate(20deg)' : 'rotate(80deg)' }} >

          </div>
          <GBox style={{ zIndex: 1, marginTop: 10, letterSpacing: 10, fontWeight: 700, display: (windowWidth >= 1100 ? 'none' : 'flex'), width: '100%', justifyContent: 'center' }}>
            <h5 style={{ fontSize: 25 }}> EXPERIENCE</h5>
          </GBox>

          <GBox

            pad="none"
            style={{
              marginTop: 10,
              display: (windowWidth < 1100 ? 'none' : 'block'),
              writingMode: 'vertical-rl', transform: 'rotate(180deg)', letterSpacing: 22,
              position: 'absolute', zIndex: 5, left: 90, top: 24
            }}
            animation="fadeIn"
          >

            <span
              style={{ fontSize: 40, fontWeight: 700, marginRight: '15%', zIndex: 2 }}
            >
              EXPERIENCE
            </span>

          </GBox>
          <div style={{ display: 'flex', width: '100%', justifyContent: 'center' }}>

            <GBox
              direction="row-responsive"
              pad="none"
              style={{ margin: 10, width: '100%', justifyContent: 'center' }}
              animation="fadeIn"
            >

              <Experience />
            </GBox>
          </div>
        </div>

        <div id="Education" style={{ display: 'flex', flexDirection: 'column', width: '100%', position: 'relative', marginTop: 20, height: 500, paddingTop: 50, backgroundColor: '#fff', color: '#000' }}>
          <GBox style={{ marginTop: 10, letterSpacing: 10, fontWeight: 700, display: (windowWidth >= 1100 ? 'none' : 'flex'), width: '100%', justifyContent: 'center' }}>
            <h5 style={{ fontSize: 25 }}> EDUCATION</h5>
          </GBox>
          <GBox

            pad="none"
            style={{
              marginTop: 10,
              display: (windowWidth < 1100 ? 'none' : 'block'),
              writingMode: 'vertical-rl', transform: 'rotate(180deg)', letterSpacing: 25,
              position: 'absolute', zIndex: 5, left: 90, top: 30
            }}
            animation="fadeIn"
          >

            <span
              style={{ fontSize: 40, fontWeight: 700, marginRight: '15%' }}
            >
              EDUCATION
            </span>

          </GBox>
          <div className="education-block" style={{ display: 'flex', width: '100%', justifyContent: 'center'}}>
            <GBox
              direction="row-responsive"
              pad="none"
              style={{ margin: 10, marginBottom: 0, width: '100%', justifyContent: 'center', }}
              animation="fadeIn"
            >

              <Education />
            </GBox>
          </div>
        </div>

      </header>

      <GBox elevation='large' direction="row" background="#010029" style={{ borderTop: "2px solid #000", padding: 14, justifyContent: "space-between" }}>

        <div>
          <p style={{ margin: 5, marginLeft: 0, padding: 0 }}>  Created By <a href="https://www.linkedin.com/in/jatinarora08/" style={{ color: "rgb(50, 177, 216)" }}>Jatin Arora </a></p>
          <GBox direction="row" >
            <a target="_self" href="https://www.linkedin.com/in/jatinarora08/"><LinkedInIcon color="success" style={{ marginLeft: 0, marginRight: 10, color: "#218ef7" }} /></a>
            <a target="_self" href="https://github.com/jatinAroraGit"><GitHubIcon style={{ marginRight: 10, color: "#fbfbfb" }} color="primary" /></a>
            <a target="_self" href="mailto:jatin.arora@outlook.com"><EmailIcon style={{ marginRight: 10, color: "#e04d01" }} color="primary" /></a>

          </GBox>
        </div>
        <p style={{ margin: 0, textAlign: 'left' }}> <b>Built with</b> <br /> React,  MUI &  Lottie </p>

      </GBox>
    </div >
  );
}

export default Homepage;
